import React from 'react'
import { Box } from '@mui/system';
import NoImage from '../../assets/images/no-image-placeholder.svg'

interface Props {
    photographer: string;
    labels: any;
};

const PortfolioModalRightNoImages: React.FunctionComponent<Props> = ({ photographer, labels }) => {
    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Box sx={{ backgroundImage: `url(${NoImage})`, width: '100%', aspectRatio: '1.5', backgroundPosition: '49% 87%', backgroundRepeat: 'no-repeat', backgroundSize: '50%' }}></Box>
            <Box sx={{ fontFamily: "'Gilroy', sans-serif", fontWeight: 600, textAlign: 'center', fontSize: 'calc(14px + 5 * ((100vw - 320px) / (1280 - 320)))', lineHeight: '36px', width: '80%', m: '0 auto 80px auto' }}>
                {`${labels.noImagesPlaceholder} ${photographer.name}`}
            </Box>
        </Box>
    )
}

export default PortfolioModalRightNoImages